import { render, staticRenderFns } from "./modal-attachment.vue?vue&type=template&id=a1d1a5aa&"
import script from "./modal-attachment.vue?vue&type=script&lang=js&"
export * from "./modal-attachment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports